import { RichText } from '@wordpress/block-editor';
import { addFilter } from '@wordpress/hooks';
import { useContext, useEffect } from '@wordpress/element';
import * as TemplateControls from '../../blocks/wp-cv-builder/controls/index';
import BlockContext from '../../blocks/wp-cv-builder/context/blockContext';
import SectionItemContext from '../../blocks/wp-cv-builder/context/sectionItemContext';
import sectionIcons from '../../options/section-icons';
import signatureImageUrl from '../../../includes/assets/img/sign-white.png';
import { __ } from '@wordpress/i18n';


const {
	HeaderOne,
	HeaderTwo,
	ProfileImage,
	HeaderThree,
	ProfileInfo,
	SocialIcon,
	About,
	Contact,
	Skills,
	Languages,
	Hobbies,
	Education,
	Experience,
	Reference,
	Awards,
	Tools,
	QrCode
} = TemplateControls;

function TemplateStyleFour() {
	const {
		attributes,
		setAttributes,
		updateSectionTitle,
		footerVisibility,
		scrollToSection,
		scrollToInspectorControl,
		togglePanel,
		handleFooterClick,
		containerRef
	} = useContext(BlockContext);
	const {
		style,
		sectionItems4,
		isFooterVisible,
		footerLink,
		signature,
		footerBtnText,
		footerBtnLink,
		showQRCode,
		socialIcon,
		sectionCountFour
	} = attributes;

	function getTranslatedDefaults() {
		return [
			{
				id: '1',
				type: 'contact',
				title: __('Contact', 'cv-builder'),
				phoneNumber: __(' +00 952 165', 'cv-builder'),
				showPhoneNumber: true,
				email: __(' info20@gmail.com', 'cv-builder'),
				showEmail: true,
				address: __('123 Main Street', 'cv-builder'),
				showAddress: true,
				website: __(' www.example.com', 'cv-builder'),
				showWebsite: true,
				country: __('USA', 'cv-builder'),
				showCountry: true,
				city: __('New York', 'cv-builder'),
				showCity: true,
				postalCode: '10001',
				showPostalCode: true,
				socialIcon: [
					{ id: 1, icon: 'Linkedin-in', link: '#' },
				]
			},
			{
				id: '2',
				type: 'skills',
				title: __('Skills', 'cv-builder'),
				items: [
					{ name: __('JavaScript', 'cv-builder'), percentage: 80 },
					{ name: __('HTML', 'cv-builder'), percentage: 90 },
					{ name: __('CSS', 'cv-builder'), percentage: 70 },
					{ name: __('React', 'cv-builder'), percentage: 85 },
					{ name: __('WordPress', 'cv-builder'), percentage: 75 },
					{ name: __('PHP', 'cv-builder'), percentage: 95 },
					{ name: __('Python', 'cv-builder'), percentage: 85 },
					{ name: __('AI', 'cv-builder'), percentage: 79 },
					{ name: __('API', 'cv-builder'), percentage: 74 },
				],
			},
			{
				id: '3',
				type: 'languages',
				title: __('Languages', 'cv-builder'),
				items: [
					{ name: __('English', 'cv-builder'), percentage: 90 },
					{ name: __('Spanish', 'cv-builder'), percentage: 75 },
					{ name: __('Arabic', 'cv-builder'), percentage: 75 },
				],
			},
			{
				id: '4',
				type: 'hobbies',
				title: __('Hobbies', 'cv-builder'),
				items: [
					{ name: __('Music', 'cv-builder'), icon: 'Music' },
					{ name: __('Movie', 'cv-builder'), icon: 'Movie' },
					{ name: __('Writing', 'cv-builder'), icon: 'Writing' },
					{ name: __('Football', 'cv-builder'), icon: 'Football' },
				],
			},
			{
				id: '5',
				type: 'about',
				title: __('About Me', 'cv-builder'),
				description: __('Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum a incidunt, voluptatibus doloribus quod praesentium quibusdam provident?', 'cv-builder'),
				dateOfBirth: '01-01-2001',
				nationality: __('USA', 'cv-builder'),
			},
			{
				id: '6',
				type: 'education',
				title: __('Education', 'cv-builder'),
				items: [
					{
						institution: __('University of California', 'cv-builder'),
						name: __('Computer Science', 'cv-builder'),
						degree: __('Bachelor', 'cv-builder'),
						city: __('California', 'cv-builder'),
						fromDate: 2020,
						toDate: 2025,
						current: false,
						country: __('USA', 'cv-builder'),
						educationDescription: __('Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.', 'cv-builder')
					},
					{
						institution: __('University of California', 'cv-builder'),
						name: __('Computer Science', 'cv-builder'),
						degree: __('Bachelor', 'cv-builder'),
						city: __('California', 'cv-builder'),
						fromDate: 2020,
						toDate: 2025,
						current: false,
						country: __('USA', 'cv-builder'),
						educationDescription: __('Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.', 'cv-builder')
					},
					{
						institution: __('University of California', 'cv-builder'),
						name: __('Computer Science', 'cv-builder'),
						degree: __('Bachelor', 'cv-builder'),
						city: __('California', 'cv-builder'),
						fromDate: 2020,
						toDate: 2025,
						current: false,
						country: __('USA', 'cv-builder'),
						educationDescription: __('Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.', 'cv-builder')
					},
				],
			},
			{
				id: '7',
				type: 'experience',
				title: __('Experience', 'cv-builder'),
				items: [
					{
						name: __('University of California', 'cv-builder'),
						designation: __('Web Developer', 'cv-builder'),
						present: false,
						fromExpDate: __('2020/10', 'cv-builder'),
						toExpDate: __('2025/05', 'cv-builder'),
						experienceDescription: __('Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.', 'cv-builder'),

					},
					{
						name: __('University of California', 'cv-builder'),
						designation: __('Web Developer', 'cv-builder'),
						present: false,
						fromExpDate: __('2020/10', 'cv-builder'),
						toExpDate: __('2025/05', 'cv-builder'),
						experienceDescription: __('Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.', 'cv-builder'),
					},
					{
						name: __('University of California', 'cv-builder'),
						designation: __('Web Developer', 'cv-builder'),
						present: false,
						fromExpDate: __('2020/10', 'cv-builder'),
						toExpDate: __('2025/05', 'cv-builder'),
						experienceDescription: __('Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.', 'cv-builder'),

					},
				],
			},
			{
				id: '8',
				type: 'reference',
				title: __('Reference', 'cv-builder'),
				items: [
					{
						name: __('John Doe', 'cv-builder'),
						jobPosition: __('CEO', 'cv-builder'),
						company: __('Company Inc', 'cv-builder'),
						phone: '1234567890',
						relation: __('Friend', 'cv-builder'),

					},
					{
						name: __('John Doe', 'cv-builder'),
						jobPosition: __('CEO', 'cv-builder'),
						company: __('Company Inc', 'cv-builder'),
						phone: '1234567890',
						relation: __('Friend', 'cv-builder'),

					},
				],
			},
			{
				id: '9',
				type: 'awards',
				title: __('Achievements & Awards', 'cv-builder'),
				items: [
					{ name: __('Top Finance Leader LATAM – Global Capital Solutions, 2022', 'cv-builder') },
					{ name: __('Outstanding Account Manager – Banco Nacional, 2018', 'cv-builder') },
					{ name: __('Reduced finance operating expenses by $250K annually', 'cv-builder') },
					{ name: __('Successfully led post-merger finance integration project across 3 countries', 'cv-builder') },
				],
			},
			{
				id: '10',
				type: 'tools',
				title: __('Tools & Technologies', 'cv-builder'),
				items: [
					{ name: __('SAP, Oracle, QuickBooks, Xero', 'cv-builder') },
					{ name: __('Microsoft Excel (Advanced), Power BI', 'cv-builder') },
					{ name: __('Tableau, Zoho Finance Suite', 'cv-builder') },
					{ name: __('CRM Tools: Salesforce, HubSpot', 'cv-builder') },
					{ name: __('Banking platforms & compliance tools', 'cv-builder') },
				],
			},
		]
	}
	addFilter(
		'bwdcv.afterProfileContact',
		'bwdcv-cv-builder-sass-main/contact-component',
		(content, props) => {
			const { attributes, setAttributes } = props;
			return '';
		}
	);
	addFilter(
		'bwdcv-social-icon-visibility',
		'main-template/hide-social-icon',
		() => true
	);
	addFilter(
		'bwdcv-footer-visibility',
		'main-template/hide-footer',
		() => true
	);

		useEffect(() => {
			if (!sectionItems4 || sectionItems4.length === 0) {
				setAttributes({
					sectionItems4: getTranslatedDefaults(),
				});
			}
		}, []);

		const firstFiveSections = sectionItems4 ? sectionItems4.slice(0, sectionCountFour) : [];
		const remainingSections = sectionItems4 ? sectionItems4.slice(sectionCountFour) : [];


	return (
		<div className={`${style} bwdcvs-main-wrapper bwdcvs-cv-builder-common`} ref={containerRef}>
			<div className="cv-builder-information">
				<div className="cv-header" onClick={() => scrollToSection('section1')} onClick={togglePanel}>
						<HeaderOne />
					</div>
				<div className="cv-body">
					<div className="bwdcv-main-wrapper">
						<div className="cv-left-content">
							{firstFiveSections.map((section, index) => (
								<div key={section.id} className={`section section-${section.type}`} onClick={() => scrollToInspectorControl(section.id)}>
									<div className="icon-title-wrap">
										<RichText
											className="section-title"
											value={section.title}
											onChange={(value) => updateSectionTitle(index, value)}
											placeholder={`Enter ${section.type} section title...`}
										/>
									</div>
									{/* About Section */}
									{section.type === "about" && (
										<About section={section} index={index} />
									)}
									{/* Contact Section */}
									{section.type === "contact" && (
										<Contact section={section} index={index} />
									)}
									<div className={`bwdcvs-content-wrapper ${section.type}`}>
										{Array.isArray(section.items) &&
											section.items.map((item, itemIndex) => (
												<SectionItemContext.Provider
													key={itemIndex}
													value={{ item, index, itemIndex }}
												>
													<div className="draggable-item">
														{section.type === 'skills' && <Skills />}
														{section.type === 'languages' && <Languages />}
														{section.type === 'hobbies' && <Hobbies />}
														{section.type === 'education' && <Education />}
														{section.type === 'experience' && <Experience />}
														{section.type === 'reference' && <Reference />}
														{section.type === 'awards' && <Awards />}
														{section.type === 'tools' && <Tools />}
													</div>
												</SectionItemContext.Provider>
											))}
									</div>
								</div>
							))}
						</div>
						<div className="cv-right-content">
							{remainingSections.map((section, index) => (
								<div key={section.id} className={`section section-${section.type}`} onClick={() => scrollToInspectorControl(section.id)}>
									<div className="icon-title-wrap">
										<RichText
											className="section-title"
											value={section.title}
											onChange={(value) => updateSectionTitle(index, value)}
											placeholder={`Enter ${section.type} section title...`}
										/>
									</div>
									{/* About Section */}
									{section.type === "about" && (
										<About section={section} index={index} />
									)}
									{/* Contact Section */}
									{section.type === "contact" && (
										<Contact section={section} index={index} />
									)}
									<div className={`bwdcvs-content-wrapper ${section.type}`}>
										{Array.isArray(section.items) &&
											section.items.map((item, itemIndex) => (
												<SectionItemContext.Provider
													key={itemIndex}
													value={{ item, index, itemIndex }}
												>
													<div className="draggable-item">
														{section.type === 'skills' && <Skills />}
														{section.type === 'languages' && <Languages />}
														{section.type === 'hobbies' && <Hobbies />}
														{section.type === 'education' && <Education />}
														{section.type === 'experience' && <Experience />}
														{section.type === 'reference' && <Reference />}
														{section.type === 'awards' && <Awards />}
														{section.type === 'tools' && <Tools />}
													</div>
												</SectionItemContext.Provider>
											))}
									</div>
								</div>
							))}
						</div>
					</div>
				</div>
				{
					(isFooterVisible && footerVisibility) && (
						<div className="footer" onClick={handleFooterClick}>
							<div className="footer-content">
								<a href={footerLink} target="_blank" className="youtube-link"><svg viewBox="0 0 1024 1024"><path d="M852.727563 392.447107C956.997809 458.473635 956.941389 565.559517 852.727563 631.55032L281.888889 993.019655C177.618644 1059.046186 93.090909 1016.054114 93.090909 897.137364L93.090909 126.860063C93.090909 7.879206 177.675064-35.013033 281.888889 30.977769L852.727563 392.447107 852.727563 392.447107Z" /></svg></a>
								<img src={signature?.url || signatureImageUrl} alt={signature?.alt || 'Placeholder'} className="signature" />
								<a href={footerBtnLink} target="_blank" className='footer-btn'>{footerBtnText}</a>
							</div>
						</div>
					)
				}
			</div>
		</div>
	)
}

export default TemplateStyleFour
